import React from 'react';

/**
 * IconButton — a square, ghost-style button for icon-only actions
 * (table row actions, toolbar buttons). Always takes an accessible `label`
 * which doubles as the tooltip. Focus ring comes from the global :focus-visible.
 */
const VARIANTS = {
    default: 'text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200 hover:bg-gray-100 dark:hover:bg-slate-700',
    brand: 'text-gray-500 dark:text-gray-400 hover:text-brand-700 dark:hover:text-brand-400 hover:bg-gray-100 dark:hover:bg-slate-700',
    danger: 'text-gray-500 dark:text-gray-400 hover:text-red-600 dark:hover:text-red-400 hover:bg-gray-100 dark:hover:bg-slate-700',
    warn: 'text-gray-500 dark:text-gray-400 hover:text-amber-600 dark:hover:text-amber-400 hover:bg-gray-100 dark:hover:bg-slate-700',
};

export default function IconButton({ icon: Icon, label, size = 20, variant = 'default', className = '', ...props }) {
    const classes = [
        'inline-flex items-center justify-center p-2 rounded-lg transition-colors',
        'disabled:opacity-40 disabled:cursor-not-allowed',
        VARIANTS[variant] || VARIANTS.default,
        className,
    ].filter(Boolean).join(' ');

    return (
        <button type="button" title={label} aria-label={label} className={classes} {...props}>
            <Icon size={size} />
        </button>
    );
}
